const { gql } = require('apollo-boost');

const GET_METER_VOTE_RESULTS = gql`
  query meterVoteResults($module_id: Int!) {
    meterVoteResults(module_id: $module_id) {
      result
      total
    }
  }
`;
export default GET_METER_VOTE_RESULTS;
